export default __webpack_public_path__ + "static/media/End User Statement.a3fa2ead.pdf";